import React from 'react';
import { Box, Typography } from '@mui/material'; // Import Typography
import logo from '../assets/GOK-logo.png'; // Import footer logo

const Footer = () => {
  return (
    <Box
      sx={{
        position: 'fixed', // Fix the footer to the bottom of the viewport
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column', // Stack items vertically
        justifyContent: 'center', // Center the content vertically
        alignItems: 'center', // Center the content horizontally
        padding: 2, // Add some padding
        //backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
        zIndex: 1000, // Ensure the footer is above other content
      }}
    >
      {/* "Powered by" Text */}
      <Typography
        variant="body2" // Use a smaller text variant
        sx={{ color: 'white', marginBottom: 1 }} // Add margin below the text
      >
        Powered by
      </Typography>

      {/* Logo */}
      <img
        src={logo}
        alt="GOK Logo"
        style={{ height: '80px' }} // Adjust the height of the logo
      />
    </Box>
  );
};

export default Footer;